import React from 'react';
import { useTranslation } from 'react-i18next';

const BetaBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center">
      <div className="inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-400/30 rounded-full shadow-lg">
        {/* Beta badge */}
        <span className="px-2.5 py-0.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold rounded-full tracking-wide uppercase shadow-md">
          {t('betaBanner.title')}
        </span>
        
        {/* Divider */}
        <div className="w-px h-4 bg-purple-300/40"></div>
        
        {/* Release date */}
        <div className="flex items-center gap-1.5">
          <svg 
            className="w-3.5 h-3.5 text-purple-300" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" 
            />
          </svg>
          <span className="text-xs font-medium text-purple-200">
            {t('betaBanner.releaseDate')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BetaBanner;
